import classNames from "classnames";
import {forwardRef, InputHTMLAttributes} from "react";

import styles from "./CheckboxInput.module.scss";

export interface CheckboxInputProps extends InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  className?: string;
  variant?: "primary" | "cloudStatus" | "marketing" | "selectionCard";
  type?: "checkbox" | "radio";
}

const CheckboxInput = forwardRef<HTMLInputElement, CheckboxInputProps>(
  ({id, className, variant = "primary", type = "checkbox", ...rest}, ref) => {
    return (
      <input
        type={type}
        className={classNames("form-check-input", styles[variant], styles.checkboxInput, className)}
        id={id}
        ref={ref}
        {...rest}
      />
    );
  }
);

CheckboxInput.displayName = "CheckboxInput";
export {CheckboxInput};
